export enum BoardViewMode {
	GRID = 'GRID',
	TABLE = 'TABLE',
}

export enum BoardsFilter {
	ALL = 'ALL', // Current default - shows boards I own and have access to
	MY_BOARDS = 'MY_BOARDS', // Only my boards that I am the owner of
	SHARED_WITH_ME = 'SHARED_WITH_ME', // SHARED or RESTRICTED boards shared with me that I am not the owner of
	EVERYONES_BOARDS = 'EVERYONES_BOARDS', // Everyone's boards (special view for permission: MANAGE_ALL_GENERATIONS)
	FEATURED_TEMPLATES = 'FEATURED_TEMPLATES', // Featured board templates visible to all users
}
